<form #form="ngForm">
    <!--    Table-->
    <div class="table-wrapper">
        <app-table
            *ngIf="blackoutPeriodsTable"
            [useStickyHeader]="false"
            [showSearch]="false"
            [table]="blackoutPeriodsTable"
            (menuItemSelected)="menuAction($event, blackoutPeriodForm)"
            [showOffset]="false"
            [showPagination]="false"
            [class.time-off-improvement]="hasTimeOffImprovement"
            title="{{ 'time-off-v3.blackoutPeriods' | translate }}"
        >
            <div class="buttons">
                <ui-button type="{{ hasTimeOffImprovement ? 'outline' : 'link' }}" (click)="showBlackoutPeriodModal()"
                    ><mat-icon svgIcon="plus"></mat-icon>{{ 'time-off-v3.addBlackoutPeriod' | translate }}</ui-button
                >
            </div>
            <div class="empty">
                <h2 class="ui centered header">
                    {{ 'time-off-v3.noBlackoutPeriodsSavedForYear' | translate: { year } }}
                </h2>
            </div>
        </app-table>
    </div>
</form>
<!--Modals-->
<app-deprecated-modal-form
    #blackoutPeriodModal
    [form]="blackoutPeriodForm"
    headerText="{{ 'time-off-v3.addBlackoutPeriod' | translate }}"
    (save)="onSave(blackoutPeriodForm)"
    (cancel)="blackoutPeriodForm.isUpdate = false"
>
    <app-blackout-period-form #blackoutPeriodForm [year]="blackoutPeriodsTable.year"></app-blackout-period-form>
</app-deprecated-modal-form>

<app-deprecated-confirmation-dialog
    #blackoutPeriodDeleteModal
    header="{{ 'time-off-v3.deleteBlackoutPeriod' | translate }}"
    description="{{ 'time-off-v3.areYouSureYouWantToDeleteThisBlackoutPeriod' | translate }}"
    label="{{ 'time-off-v3.delete' | translate }}"
    [negative]="true"
>
</app-deprecated-confirmation-dialog>
